/**
 * @desc 导出批次列表
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.batchMaster.exportListBatch.Params, options?: any) {
  return updateResponse(
    http(URL + `/fulfilment/batch/export/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
